/**
 * 库存管理api
 */
export default {
 getStoreInventoryList: "/inventory/listPage",    // 门店库存列表
};
